import KatalLogger, {Level} from "@amzn/katal-logger";
import {v4 as uuidv4} from 'uuid';
import {getStationCode} from "../network/NetworkUtil";
import {REGION, STAGE} from "./Constants";
import {getRegion, getStage, isOneBox} from "./Util";

const KATAL_LOGGER_URL_MAP = new Map();
KATAL_LOGGER_URL_MAP.set(`${REGION.NA}-${STAGE.DEV}`, "https://bb5mndmcp3.execute-api.us-west-2.amazonaws.com/prod/v1/log");
KATAL_LOGGER_URL_MAP.set(`${REGION.EU}-${STAGE.DEV}`, "https://bb5mndmcp3.execute-api.us-west-2.amazonaws.com/prod/v1/log");
KATAL_LOGGER_URL_MAP.set(`${REGION.JP}-${STAGE.DEV}`, "https://bb5mndmcp3.execute-api.us-west-2.amazonaws.com/prod/v1/log");

KATAL_LOGGER_URL_MAP.set(`${REGION.NA}-${STAGE.BETA}`, "https://bb5mndmcp3.execute-api.us-west-2.amazonaws.com/prod/v1/log");
KATAL_LOGGER_URL_MAP.set(`${REGION.EU}-${STAGE.BETA}`, "https://bb5mndmcp3.execute-api.us-west-2.amazonaws.com/prod/v1/log");
KATAL_LOGGER_URL_MAP.set(`${REGION.JP}-${STAGE.BETA}`, "https://bb5mndmcp3.execute-api.us-west-2.amazonaws.com/prod/v1/log");

KATAL_LOGGER_URL_MAP.set(`${REGION.NA}-${STAGE.GAMMA}`, "https://2gmjwy8m0k.execute-api.us-east-1.amazonaws.com/prod/v1/log");
KATAL_LOGGER_URL_MAP.set(`${REGION.EU}-${STAGE.GAMMA}`, "https://udy6seu24m.execute-api.eu-west-1.amazonaws.com/prod/v1/log");
KATAL_LOGGER_URL_MAP.set(`${REGION.JP}-${STAGE.GAMMA}`, "https://wsdqjmlfx8.execute-api.us-west-2.amazonaws.com/prod/v1/log");
KATAL_LOGGER_URL_MAP.set(`${REGION.IN}-${STAGE.GAMMA}`, "https://ujclicxqg4.execute-api.eu-west-1.amazonaws.com/prod/v1/log");

KATAL_LOGGER_URL_MAP.set(`${REGION.NA}-${STAGE.PROD}`, "https://ahe32d1qd2.execute-api.us-east-1.amazonaws.com/prod/v1/log");
KATAL_LOGGER_URL_MAP.set(`${REGION.EU}-${STAGE.PROD}`, "https://nilhqr4mh5.execute-api.eu-west-1.amazonaws.com/prod/v1/log");
KATAL_LOGGER_URL_MAP.set(`${REGION.JP}-${STAGE.PROD}`, "https://x1hqelxrnh.execute-api.us-west-2.amazonaws.com/prod/v1/log");
KATAL_LOGGER_URL_MAP.set(`${REGION.IN}-${STAGE.PROD}`, "https://jchmxc3x5h.execute-api.eu-west-1.amazonaws.com/prod/v1/log");

function getLoggerURL() {
    const key = `${getRegion()}-${getStage()}`
    return KATAL_LOGGER_URL_MAP.get(key);
}

function getTimezone() {
    try {
        return Intl.DateTimeFormat().resolvedOptions().timeZone;
    } catch (ignored) {
    }
}

export const Logger = {
    log: null,
    info(message, context) {
        //this.log && this.log.info(message, context);
    },
    error(message, error, context) {
        //this.log && this.log.error(message, error, context);
    },
    fatal(message, error, context) {
        //this.log && this.log.fatal(message, error, context);
    },
    initialise() {
        const stage = getStage();
        this.log = new KatalLogger({
            url: getLoggerURL(),
            logThreshold: Level.INFO,
            decodeStackTrace: true,
            maxLogLineSize: 10000,
            context: {
                sessionId: uuidv4(),
                stationCode: getStationCode(),
                isOneBox: isOneBox(),
                timezone: getTimezone()
            },
            logToConsole: stage !== STAGE.PROD
        });
        this.log.addErrorListener();
    }
}


// WEBPACK FOOTER //
// ./src/components/util/Logger.js